import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Mumbaitopimprichichwad() {



    const cardData = {

keyword: "Mumbai to Pimpri Chinchwad Cabs",

headingDescription:
    "Mumbai Airport Cab offers reliable and affordable Mumbai to Pimpri Chinchwad Cabs for business travel, corporate commuting, family trips, weekend getaways, airport transfers, and one-way or round-trip journeys. We provide a wide range of well-maintained vehicles including Sedan, SUV, Innova Crysta, Ertiga, Kia Carens, Tempo Traveller, Luxury Urbania, and Mini Bus with professional and experienced chauffeurs. With 24x7 availability, transparent pricing, doorstep pickup across Mumbai, and safe highway travel via the Mumbai–Pune Expressway, we ensure a smooth, comfortable, and hassle-free journey to Pimpri Chinchwad and nearby Pune industrial zones.",

topPlaces: [
    {
        title: "Lonavala",
        description:
            "Lonavala is one of the most popular hill stations near Mumbai and Pune, famous for lush green valleys, waterfalls, caves, and misty monsoon views. Travelers often stop here for relaxation, photography, and short breaks during outstation cab journeys."
    },
    {
        title: "Khandala",
        description:
            "Khandala is a scenic twin hill station of Lonavala known for breathtaking viewpoints, deep valleys, and peaceful weather. It is a preferred stop for families and couples traveling between Mumbai and Pune regions."
    },
    {
        title: "Mahabaleshwar",
        description:
            "Mahabaleshwar is a famous hill station known for strawberry farms, dense forests, lakes, and panoramic viewpoints. It is a top weekend getaway destination for travelers booking outstation cabs from Mumbai."
    },
    {
        title: "Panchgani",
        description:
            "Panchgani is a calm hill station near Mahabaleshwar known for Table Land plateau, colonial charm, boarding schools, and scenic valley views, making it ideal for peaceful family trips."
    },
    {
        title: "Shirdi",
        description:
            "Shirdi is one of India’s most important pilgrimage destinations dedicated to Sai Baba, attracting millions of devotees every year for spiritual visits and darshan."
    },
    {
        title: "Nashik",
        description:
            "Nashik is a major religious and wine tourism destination known for Trimbakeshwar Jyotirlinga, Godavari ghats, vineyards, and spiritual significance."
    },
    {
        title: "Goa",
        description:
            "Goa is India’s most famous beach destination known for nightlife, beaches, water sports, and scenic coastal beauty, making it a top long-distance travel choice from Mumbai."
    },
    {
        title: "Aurangabad",
        description:
            "Aurangabad is a historical city famous for Ajanta and Ellora Caves, Bibi Ka Maqbara, and rich Mughal and Maratha heritage tourism."
    },
    {
        title: "Kolhapur",
        description:
            "Kolhapur is known for Mahalaxmi Temple, cultural heritage, spicy cuisine, and historical forts, making it a popular pilgrimage and cultural destination."
    },
    {
        title: "Ratnagiri",
        description:
            "Ratnagiri is a beautiful Konkan coastal destination famous for Ganpatipule Temple, clean beaches, mango farms, and scenic sea routes."
    }
],



services: [
{
name: "Mumbai to Pimpri Chinchwad Cab",
description: "Mumbai to Pimpri Chinchwad Cab service by 1Touch Cabs provides safe, comfortable, and reliable intercity transportation for business travelers, families, corporate employees, students, and tourists. We offer a wide range of well-maintained vehicles including Sedan, Swift Dzire, Ertiga, Kia Carens, Innova, Innova Crysta, SUV, Luxury Cars, and Tempo Traveller options. Our professional chauffeurs ensure smooth highway driving via the Mumbai–Pune Expressway with timely pickups, luggage assistance, and stress-free travel. With 24x7 availability, transparent pricing, easy online booking, and dependable customer support, we make Mumbai to PCMC travel convenient, affordable, and comfortable."
},
{
name: "Mumbai to Pimpri Chinchwad Taxi",
description: "Mumbai to Pimpri Chinchwad Taxi service offers dependable and comfortable transportation for passengers traveling between Mumbai and PCMC. 1Touch Cabs ensures clean vehicles, experienced drivers, flexible pickup locations, and safe highway travel with punctual service and affordable pricing for all travel needs."
},
{
name: "Mumbai to PCMC Cab Service",
description: "Mumbai to PCMC Cab Service provides efficient and reliable transportation between Mumbai and Pimpri Chinchwad. 1Touch Cabs offers well-maintained vehicles, professional chauffeurs, and flexible travel options designed for family trips, corporate travel, and daily intercity commuting."
},
{
name: "Mumbai to Pimpri Chinchwad Taxi Service",
description: "Mumbai to Pimpri Chinchwad Taxi Service ensures smooth and safe travel with experienced drivers and comfortable air-conditioned vehicles. 1Touch Cabs focuses on punctuality, customer satisfaction, and hassle-free booking for all types of travelers."
},
{
name: "Mumbai to PCMC Taxi Service",
description: "Mumbai to PCMC Taxi Service offers reliable intercity transportation with transparent pricing and professional chauffeurs. 1Touch Cabs ensures comfortable seating, safe driving, and timely arrivals for business, personal, and family travel needs."
},
{
name: "Mumbai to Pimpri Chinchwad One Way Cab",
description: "Mumbai to Pimpri Chinchwad One Way Cab service provides cost-effective travel without return charges. 1Touch Cabs offers affordable pricing, flexible pickup options, and comfortable vehicles for passengers who need one-way intercity travel."
},
{
name: "Mumbai to Pimpri Chinchwad Cab Booking",
description: "Mumbai to Pimpri Chinchwad Cab Booking service allows quick and easy reservation through online or phone booking. 1Touch Cabs provides instant confirmation, multiple vehicle choices, and 24x7 customer support for seamless travel planning."
},
{
name: "Mumbai to Pimpri Chinchwad Car Rentals",
description: "Mumbai to Pimpri Chinchwad Car Rental service offers flexible travel solutions for short trips, business travel, and long-distance journeys. 1Touch Cabs provides well-maintained vehicles with professional chauffeurs for a comfortable travel experience."
},
{
name: "Mumbai to Pimpri Chinchwad Outstation Cab",
description: "Mumbai to Pimpri Chinchwad Outstation Cab service ensures safe and reliable long-distance travel with experienced drivers and clean, comfortable vehicles. 1Touch Cabs provides affordable fares and smooth highway journeys via the expressway."
},
{
name: "Mumbai to Pimpri Chinchwad Innova Cab",
description: "Mumbai to Pimpri Chinchwad Innova Cab service is ideal for families and groups seeking spacious and comfortable travel. 1Touch Cabs offers well-maintained Innova vehicles with professional chauffeurs ensuring a smooth and relaxed journey."
},
{
name: "Mumbai to Pimpri Chinchwad Innova Crysta Cab",
description: "Mumbai to Pimpri Chinchwad Innova Crysta Cab service provides premium comfort with luxury seating, ample luggage space, and smooth highway performance. 1Touch Cabs ensures a high-quality travel experience for families and corporate travelers."
},
{
name: "Mumbai to Pimpri Chinchwad Ertiga Cab",
description: "Mumbai to Pimpri Chinchwad Ertiga Cab service offers affordable and comfortable travel for small families and groups. 1Touch Cabs provides clean vehicles, experienced drivers, and safe intercity transportation at budget-friendly rates."
},
{
name: "Mumbai to Pimpri Chinchwad Sedan Cab",
description: "Mumbai to Pimpri Chinchwad Sedan Cab service provides economical and comfortable travel for individuals and couples. 1Touch Cabs ensures smooth rides with professional chauffeurs and well-maintained air-conditioned sedans."
},
{
name: "Mumbai to Pimpri Chinchwad Swift Dzire Cab",
description: "Mumbai to Pimpri Chinchwad Swift Dzire Cab service offers affordable and efficient travel with comfortable seating and reliable drivers. 1Touch Cabs ensures safe, punctual, and budget-friendly intercity transportation."
},
{
name: "Mumbai to Pimpri Chinchwad SUV Taxi",
description: "Mumbai to Pimpri Chinchwad SUV Taxi service provides spacious and powerful vehicles suitable for families, groups, and luggage-heavy travel. 1Touch Cabs ensures comfort, safety, and smooth highway driving for long journeys."
},
{
name: "Mumbai to Pimpri Chinchwad Kia Carens Cab",
description: "Mumbai to Pimpri Chinchwad Kia Carens Cab service offers modern comfort with premium seating and ample space for family and group travel. 1Touch Cabs ensures a smooth and enjoyable journey with professional chauffeurs."
},
{
name: "Mumbai to Pimpri Chinchwad Luxury Cab",
description: "Mumbai to Pimpri Chinchwad Luxury Cab service provides premium travel experience with high-end vehicles, professional chauffeurs, and top-class comfort. 1Touch Cabs is ideal for VIP, corporate, and executive travel requirements."
},
{
name: "Mumbai to Pimpri Chinchwad AC Taxi",
description: "Mumbai to Pimpri Chinchwad AC Taxi service ensures fully air-conditioned comfortable travel for all passengers. 1Touch Cabs offers clean vehicles, experienced drivers, and reliable service for a smooth journey."
},
{
name: "Mumbai to Pimpri Chinchwad Tempo Traveller",
description: "Mumbai to Pimpri Chinchwad Tempo Traveller service is ideal for large groups, corporate outings, family tours, and weekend trips. 1Touch Cabs provides spacious seating, professional chauffeurs, and safe long-distance travel for group journeys."
}
],

tableData: [
["Mumbai to Pimpri Chinchwad Cab","Mumbai to Pimpri Chinchwad Taxi"],
["Mumbai to PCMC Cab Service","Mumbai to Pimpri Chinchwad Taxi Service"],
["Mumbai to PCMC Taxi Service","Mumbai to Pimpri Chinchwad One Way Cab"],
["Mumbai to Pimpri Chinchwad Cab Booking","Mumbai to Pimpri Chinchwad Car Rentals"],
["Mumbai to Pimpri Chinchwad Outstation Cab","Mumbai to Pimpri Chinchwad Innova Cab"],
["Mumbai to Pimpri Chinchwad Innova Crysta Cab","Mumbai to Pimpri Chinchwad Ertiga Cab"],
["Mumbai to Pimpri Chinchwad Sedan Cab","Mumbai to Pimpri Chinchwad Swift Dzire Cab"],
["Mumbai to Pimpri Chinchwad SUV Taxi","Mumbai to Pimpri Chinchwad Kia Carens Cab"],
["Mumbai to Pimpri Chinchwad Luxury Cab","Mumbai to Pimpri Chinchwad AC Taxi"],
["Mumbai to Pimpri Chinchwad Tempo Traveller","Mumbai to Pimpri Chinchwad Cab Service"]
],













whychoose: [
    {
        WhyChooseheading: "Reliable Mumbai to Pimpri Chinchwad Cab Service",
        WhyChoosedescription: "Mumbai Airport Cabs provides dependable Mumbai to Pimpri Chinchwad Cab services for corporate travelers, IT professionals, business executives, families, students, and daily commuters seeking comfortable transportation."
    },
    {
        WhyChooseheading: "Convenient Travel Between Mumbai and PCMC",
        WhyChoosedescription: "Enjoy hassle-free transportation from Mumbai to Pimpri Chinchwad with comfortable vehicles, professional drivers, and flexible pickup and drop services."
    },
    {
        WhyChooseheading: "Perfect for Corporate and Industrial Travel",
        WhyChoosedescription: "Pimpri Chinchwad is a major industrial and IT hub with numerous manufacturing companies, business parks, educational institutions, and corporate offices."
    },
    {
        WhyChooseheading: "Wide Range of Vehicle Options",
        WhyChoosedescription: "Customers can choose Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, Mini Buses, and premium vehicles according to passenger count and travel requirements."
    },
    {
        WhyChooseheading: "One-Way and Round Trip Booking Available",
        WhyChoosedescription: "Whether you need a one-way transfer, round trip, same-day return, corporate visit, or customized travel package, we provide flexible booking options."
    },
    {
        WhyChooseheading: "Pickup Available Across Mumbai",
        WhyChoosedescription: "Doorstep pickup services are available from Mumbai Airport, Navi Mumbai, Thane, Kalyan, Dombivli, Andheri, Borivali, Bandra, Dadar, Powai, and nearby locations."
    },
    {
        WhyChooseheading: "Experienced Drivers for Expressway Travel",
        WhyChoosedescription: "Our professional chauffeurs are experienced on the Mumbai-Pune Expressway and ensure safe, smooth, and comfortable transportation throughout the journey."
    },
    {
        WhyChooseheading: "Ideal for Corporate Employees and Families",
        WhyChoosedescription: "From business travelers and IT professionals to families and students, we provide suitable transportation solutions for every travel requirement."
    }
]
};

const faqData = [
    {
        question: "Why do travelers book Mumbai to Pimpri Chinchwad Cabs?",
        answer: "Pimpri Chinchwad attracts visitors for corporate meetings, industrial visits, IT jobs, educational purposes, family visits, and business travel."
    },
    {
        question: "Can I book a one-way cab from Mumbai to Pimpri Chinchwad?",
        answer: "Yes, one-way cab services are available along with round-trip and customized travel packages."
    },
    {
        question: "Which vehicle is suitable for Mumbai to Pimpri Chinchwad travel?",
        answer: "Sedan cars, Ertiga, Innova, Innova Crysta, Kia Carens, SUVs, Tempo Travellers, and Mini Buses are available according to passenger count and travel preferences."
    },
    {
        question: "Can corporate employees use this service regularly?",
        answer: "Yes, many IT professionals, company executives, consultants, and corporate teams use our Mumbai to Pimpri Chinchwad cab services regularly."
    },
    {
        question: "Do you provide cab services for industrial visits?",
        answer: "Yes, we provide transportation for industrial areas, MIDC locations, manufacturing plants, corporate offices, and business parks across PCMC."
    },
    {
        question: "Are Tempo Travellers available for group travel?",
        answer: "Yes, Tempo Travellers and Mini Buses are available for corporate teams, family groups, educational tours, and employee transportation."
    },
    {
        question: "Can I schedule same-day return travel?",
        answer: "Yes, customers can choose same-day return trips depending on their meeting schedules and travel requirements."
    },
    {
        question: "Can I get pickup from Mumbai Airport?",
        answer: "Yes, pickup services are available from Mumbai Airport, hotels, railway stations, offices, and residential locations."
    },
    {
        question: "Is advance booking recommended for Mumbai to Pimpri Chinchwad travel?",
        answer: "Yes, advance booking helps secure your preferred vehicle and ensures smooth travel planning, especially during weekdays and peak business hours."
    },
    {
        question: "How can I book a Mumbai to Pimpri Chinchwad Cab?",
        answer: "Bookings can be made through phone calls, WhatsApp messages, or online inquiries with Mumbai Airport Cabs."
    }
];

const testimonials = [
    {
        id: 1,
        name: "Mr. Sachin Kulkarni",
        feedback:
            "I frequently travel from Mumbai to Pimpri Chinchwad for business meetings. Mumbai Airport Cabs always provides punctual service, comfortable vehicles, and professional drivers.",
        rating: 5
    },
    {
        id: 2,
        name: "Mrs. Vaishali Patil",
        feedback:
            "We booked a cab for a family visit to PCMC and had a wonderful experience. The vehicle was clean, spacious, and the journey was smooth throughout.",
        rating: 5
    }
];




















   const Images = [
    { place: "/images/keyword/114.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/113.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/112.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/111.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/110.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/109.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/108.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/107.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/106.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/105.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/104.jpg", text: "Mumbai to 5 Jyotirlinga Cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/103.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/102.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/101.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/100.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/99.jpg", text: "Mumbai to Matheran Cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/98.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Dhule-Cab-Booking" },
    { place: "/images/keyword/97.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/96.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/95.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/94.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/93.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/92.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/91.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/90.jpg", text: "Mumbai to Daman Taxi", link: "Mumbai-to-Daman-Taxi" },
];














const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Pimpri Chinchwad Cab Service",
  "image": "https://www.mumbaiairportcabs.com/assets/images/mumbai-to-pimpri-chinchwad-cab.jpg",
  "description": "Book Mumbai to Pimpri Chinchwad (PCMC) cab service for safe, comfortable, and affordable intercity travel. Mumbai Airport Cabs offers reliable AC taxi service with professional drivers, clean vehicles, and 24x7 availability for one-way and round trips.",
  "brand": {
    "@type": "Brand",
    "name": "Mumbai Airport Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.7",
    "ratingCount": "6100"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹8/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.mumbaiairportcabs.com/mumbai-to-pimpri-chinchwad-cabs"
  }
};




    return (
        <div>


<Helmet>
  <title>Mumbai to Pimpri Chinchwad Cab Service | PCMC Taxi Booking | +91 9545731161</title>

  <meta
    name="description"
    content="Book Mumbai to Pimpri Chinchwad cab service for safe and comfortable travel. Affordable PCMC taxi service with professional drivers and 24x7 booking support."
  />

  <meta
    name="keywords"
    content="mumbai to pimpri chinchwad cab, Mumbai to Pimpri Chinchwad Cab, Mumbai to PCMC Cab, Mumbai to Pimpri Chinchwad Taxi, Mumbai to Pimpri Chinchwad Cab Service, Mumbai to Pimpri Chinchwad Taxi Service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>






            <div
                className="breadcumb-wrapper"
                style={{
                    backgroundImage: "url('/images/breadcumb/breadcumb-bg.jpg')",
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                }}
            >
                <div className="container z-index-common">
                    <div className="breadcumb-content">
                        <h1 className="breadcumb-title">{cardData.keyword}</h1>
                    </div>
                </div>
            </div>


















            <section>
                <div className="container-fluid" >
                    <div className="row container-fluid">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/10.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#1A4160', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Mumbai Airport Cab: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>


                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div key={index} className="service-row">
                                        {/* <div className="service-icon">
                      🚗
                    </div> */}
                                        <div>
                                            <h4 className="service-title">{service.name}</h4>
                                            <p className="service-desc">{service.description}</p>
                                        </div>
                                    </div>
                                ))}
                            </div>


                            <table className="table table-responsive Border-key my-2">
                                <tbody className=' Border-key'>
                                    {cardData.tableData.map((row, rowIndex) => (
                                        <tr className='Border-key ' key={rowIndex}>
                                            {row.map((cell, cellIndex) => (
                                                <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                                            ))}
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                            <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
                            <BusRatesTable />

                            <div id="why-choose-section" className="why-choose-section">


                                {/* Section Title */}
                                <h2 className="section-title text-white">
                                    Why Choose <span>Mumbai Airport Cabs</span>
                                </h2>


                                {/* Cards */}
                                <div className="cards-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div key={index} className="why-card">
                                            <div className="icon-circle">{index + 1}</div>
                                            <h4 className="card-heading">{item.WhyChooseheading}</h4>
                                            <p className="card-desc">{item.WhyChoosedescription}</p>
                                        </div>
                                    ))}
                                </div>
                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Mumbai Airport Cabs </h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-telephone-fill"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+919545731161" className="pc-call">+91 9545731161</a>
                                        </div>

                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/919545731161"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+919545731161" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-envelope-fill"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@mumbaiairportcabs.com" className="pc-email">
                                            booking@mumbaiairportcabs.com
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="bi bi-geo-alt-fill"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Mumbai Airport Cabs</strong><br />

                                            SAWANT SADAN 05 Ramachandra cold drinks House,
                                            Near SBI Bank Nehru Road Opp Noble Medical,
                                            Vile Parle East Mumbai, 400057
                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Mumbaitopimprichichwad;